<template>
    <Modal :open="open" :is-card="true" :show-close-icon="true" :is-dismissed-on-click-backdrop="false" @close="closeOptionInfoModal" :narrow="false">
        <h2 class="title">{{ info.value }}</h2>

        <ul class="ul--no-padding">
            <li class="info-item" v-for="(value, index) in info.info" :key="index">{{ value.spec_name }}</li>
        </ul>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";

export default {
    props: {
        open: {
            default: false,
        },
        info: {
            type: [Array, Object],
            required: true
        },
    },
    components: {
        Modal
    },
    methods: {
        closeOptionInfoModal: function () {
            this.$emit('close-option-info-modal');
        },
    }
}
</script>

<style lang="scss" scoped>
.title {
    text-align: center;
    color: #192A44;
    margin-bottom: 10px;
}

.info-item {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
}
</style>